import { useSelector } from "react-redux";
import { getSignalTypePercentages } from "../utility/helper";

function useInsightOverallSignal(coin) {
  const {
    liveSuggestion: { suggestions },
    newInsightState: { signalData, signalTableColumns },
  } = useSelector((state) => state);

  const liveData = suggestions.find((s) => s.symbol === coin);

  const percentages = getSignalTypePercentages(
    signalData.filter((s) => s.coin === coin),
    signalTableColumns,
    liveData,
  );

  const { buy, sell, hold } = percentages;

  const signalSuggestion =
    !buy && !sell && !hold
      ? ""
      : buy > sell && buy >= hold
        ? "Buy"
        : sell >= hold
          ? "Sell"
          : hold
            ? "Hold"
            : "";
  const finalSuggestion =
    liveData && liveData?.prediction !== "Hold"
      ? liveData?.prediction
      : signalSuggestion || liveData?.prediction || "";
  const signalConfidence = percentages?.[finalSuggestion?.toLowerCase()];

  return { finalSuggestion, signalConfidence };
}

export default useInsightOverallSignal;
